import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { showErrorToast } from '../../../../../../common/global/helpers';
import { resources } from '../../../../resources/resources';
import { employeeFilesService } from '../../../../services/employee-files';

export default function CustomToastContent({
  archiveId,
  archiveName,
}: {
  archiveId: string;
  archiveName: string;
}) {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { t: translate } = useTranslation();
  const handleDownloadFiles = async () => {
    setIsLoading(true);

    const response = await employeeFilesService.downloadEmployeesFiles(
      archiveId,
      archiveName,
    );
    if (response.hasErrors) {
      showErrorToast(
        translate(resources.admin.fileImport.validation.genericError),
      );
    }
    setIsLoading(false);
  };
  return (
    <div>
      <h4>{translate(resources.employeeFiles.archiveReady.tile)}</h4>
      {!isLoading ? (
        <p>
          {translate(resources.employeeFiles.archiveReady.message)}{' '}
          <a onClick={handleDownloadFiles}>
            {translate(resources.employeeFiles.archiveReady.download)}
          </a>
        </p>
      ) : (
        <p>
          {translate(resources.employeeFiles.archiveReady.isDownloadingMessage)}
        </p>
      )}
    </div>
  );
}
